// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { CircularProgress, Fade } from '@mui/material';
import { Heading } from '@shared/ui-kit/components';
import { type FC, type PropsWithChildren, type ReactNode } from 'react';

interface PageContainerProps extends PropsWithChildren {
  actionBtn?: ReactNode;
  className?: string;
  titlePage?: ReactNode;
  subtitlePage?: string;
  alertTitle?: () => void;
  showBottomButtons?: boolean;
  loading?: boolean;
}

export const PageContainer: FC<PageContainerProps> = ({
  actionBtn,
  children,
  className = '',
  titlePage,
  showBottomButtons = false,
  loading,
}) => {
  return (
    <div
      className={`relative mx-4 my-2 rounded-lg md:mx-16 md:my-8 ${className} max-w-screen-2xl focus-visible:!outline-none 2xl:mx-auto 2xl:w-full 2xl:px-16`}
      data-testid="pagecontainer"
      id="pagecontainer"
    >
      <Fade in={loading}>
        <div className="absolute left-0 top-0 z-20 flex h-full w-full items-start justify-center bg-page/50">
          <CircularProgress size={75} className="mt-[25%]" />
        </div>
      </Fade>
      {titlePage ? (
        <div className="relative mb-6 flex items-center justify-between">
          {titlePage && <Heading variant="h1" title={titlePage} />}
          {actionBtn}
        </div>
      ) : (
        actionBtn && (
          <div className="page-container-actions-btn absolute right-0 flex gap-x-5">
            {actionBtn}
          </div>
        )
      )}

      {children}
      {showBottomButtons && (
        <div className="mt-8 flex justify-end">{actionBtn}</div>
      )}
    </div>
  );
};
